import DataGridConfirmation from './DataGridConfirmation';

export default DataGridConfirmation;
